export default (axios, baseURL) => async () => {
  const url = `/v2/auth/session-info`;
  const axiosConfig = {
    method: 'GET',
    baseURL,
    url,
    skipAuthLogout: true,
    withCredentials: true
  };
  try {
    const axiosResponse = await axios(axiosConfig);
    return axiosResponse.data;
  } catch (apiErr) {
    return { crossTenantSession: false };
  }
};
